import Vue from 'vue'
import Vuex from 'vuex'
import api from './api.js'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		accessToken: localStorage.getItem('accessToken'),
	},
	mutations: {
		SET_ACCESS_TOKEN(state, data) {
			state.accessToken = data
		},
	},
	getters: {
		accessToken(state) {
			return state.accessToken
		},
	},
	actions: {

		getCode(state, data) {
			return api.post('/sgameweb/api/auth/sms/send', data)
		},
		setLogin(state, data) {
			return api.post('/sgameweb/api/auth/localLogin', data)
		},
		getSignInDay(state, data) {
			return api.get('/sgameweb/api/appointment/getSignInDay', data)
		},
		setSign() {
			return api.post('/sgameweb/api/appointment/signIn', {})
		},
		getLotteryRecord() {
			return api.post('/sgameweb/api/lottery/getLotteryRecord', {})
		},
		randomAward() {
			return api.post('/sgameweb/api/lottery/randomAward', {})
		},
		getLotteryLeftNum() {
			return api.post('/sgameweb/api/lottery/getLotteryLeftNum', {})
		},
		savePersnalInfo(state, data) {
			return api.post('/sgameweb/api/lottery/savePersnalInfo', data)
		},
		addLotteryNum(state, data) {
			return api.post('/sgameweb/api/appointment/addLotteryNum', data)
		},
		getServerRoleList(state, data) {
			return api.get('/sgameweb/api/lottery/getServerRoleList', data)
		},
		exchangeLottery(state, data) {
			return api.post('/sgameweb/api/lottery/exchangeLottery', data)
		}
	},
	modules: {}
})
